import { isNil } from 'lodash-es'

export const coerceArray = <T>(value: T | T[]) => {
  if (isNil(value)) {
    return value
  }

  return Array.isArray(value) ? value : [value]
}
